import React from 'react';
import {observer} from 'mobx-react';
import {Button} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import {absoluteDateFormatter} from 'shared/tools';

const ShareOrWriteButton = observer(({uiState, model}) => {
  const {cycle} = uiState;

  if (!cycle.managerType) {
    return null;
  }

  return (
    <Button
      trait='default'
      size='sm'
      onClick={
        () => model.currentEmployeeManagerReview.hasLink('share') ?
          uiState.openShareWithRevieweeModal(model) : uiState.goToWriteReview(model)
      }
    >
      <FormattedMessage
        id={
          model.currentEmployeeManagerReview.hasLink('share') ?
            'performance_reviews.view.Share' : 'performance_reviews.view.Write'
        }
      />
    </Button>
  );
});

const RevieweeActionButton = observer(({uiState, model}) => {
  const {cycle} = uiState;

  if (model.currentEmployeeManagerReview?.sharedAt){
    return <FormattedMessage
      id={`performance_reviews.view.${!!cycle.managerType ? 'SHARED_AT_MESSAGE' : 'CLOSED_AT_MESSAGE'}`}
      values={{sharedAt: absoluteDateFormatter(model.sharedAt)}}
    />;
  } else {
    return <ShareOrWriteButton uiState={uiState} model={model}/>;
  }
});

export default RevieweeActionButton;
